import { jsPDF } from 'jspdf';
import { formatPKR } from './currencyFormatter';
import { addPdfBrandLogo } from './pdfLogo';

export async function downloadPartyReceivingReceiptPdf({
  businessName,
  branchName,
  partyName,
  amount,
  receiptType,
  receiptDate,
  downloadedAtLabel,
  referenceNumber,
  purpose,
  receivedBy,
  currentBalanceLabel,
  notes
}) {
  const doc = new jsPDF({ unit: 'mm', format: 'a4' });
  const margin = 14;
  const amountNum = parseFloat(amount) || 0;
  const { nextY } = await addPdfBrandLogo(doc, { maxWidthMm: 30, startY: 8, gapAfterMm: 3 });
  let y = nextY;

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(15);
  doc.text('Receiving Receipt', margin, y);
  y += 7;

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  doc.text(String(businessName || 'Business'), margin, y);
  y += 6;
  doc.text(`Branch: ${branchName || '—'}`, margin, y);
  y += 6;
  doc.text(`Party: ${partyName || '—'}`, margin, y);
  y += 6;
  doc.text(`Type: ${receiptType === 'payment_made' ? 'Payment made' : 'Payment received'}`, margin, y);
  y += 6;
  doc.text(`Amount: ${formatPKR(amountNum)}`, margin, y);
  y += 6;
  doc.text(`Date: ${receiptDate || new Date().toISOString().split('T')[0]}`, margin, y);
  y += 6;
  doc.text(`Downloaded at: ${downloadedAtLabel || new Date().toLocaleString('en-PK')}`, margin, y);
  y += 6;
  doc.text(`Reference: ${referenceNumber || '—'}`, margin, y);
  y += 6;
  doc.text(`Received by: ${receivedBy || '—'}`, margin, y);
  y += 6;
  doc.text(`Current balance: ${currentBalanceLabel || '—'}`, margin, y);
  y += 8;

  doc.setFont('helvetica', 'bold');
  doc.text('Purpose', margin, y);
  y += 5;
  doc.setFont('helvetica', 'normal');
  doc.text(String(purpose || '—'), margin, y, { maxWidth: 180 });
  y += 12;

  if (String(notes || '').trim()) {
    doc.setFont('helvetica', 'bold');
    doc.text('Notes', margin, y);
    y += 5;
    doc.setFont('helvetica', 'normal');
    doc.text(String(notes).trim(), margin, y, { maxWidth: 180 });
    y += 12;
  }

  y += 8;

  doc.text('Receiver signature: ____________________', margin, y);
  doc.text('Sender signature: _____________________', margin + 95, y);

  const safeParty = String(partyName || 'party').replace(/[^\w-]/g, '-').slice(0, 30);
  doc.save(`receiving-receipt-${safeParty}.pdf`);
}
